import ModalSlot, { slot } from "../../components/ModalSlot"

const links = [...slot(10), {
    width: "28.4%",
    height: "4.8%",
    top: "88.7%",
    left: "34.8%",
}]

const slots = [
    null,
    {
        href: "https://www.assure.securityforum.org",
        label: "ISF Assure"
    },
    {
        href: "https://www.isflive.org/s/article/The-Standard-of-Good-Practice-for-Information-Security-2022-consolidated-cross-reference",
        label: "Consolidate cross reference"
    },
    {
        href: "https://www.isflive.org/s/article/The-Standard-of-Good-Practice-for-Information-Security-2022-cross-reference-to-the-Cloud-Security-Alliance-Cloud-Controls-Matrix-CSA-CCM-v4",
        label: "Cross reference to CSA CCM V4"
    },
    {
        href: "https://www.isflive.org/s/article/sogp-2022-cross-reference-to-ISO-IEC-27002-2022",
        label: "Cross reference to ISO/IEC 27002:2022"
    },
    {
        href: "https://www.isflive.org/s/article/vulnerability-management-beyond-patching",
        label: "Vulnerability Management: Beyond patching"
    },
    {
        href: "https://www.isflive.org/s/article/securing-operational-machine-learning-systems",
        label: "Security Operational Machine Learning Systems"
    },
    {
        href: "https://www.isflive.org/s/article/ics-insights-ot-security-architecture",
        label: "ICS Insights: OT security architecture"
    },
    {
        href: "https://www.isflive.org/s/article/Leadership-Insights-Unlocking-the-business-value-of-security",
        label: "Leadership Insights: Unlocking the business value of security"
    },
    {
        href: "https://www.isflive.org/s/article/Threat-Horizon-2025",
        label: "Thread Horizon 2025"
    },
    {
        href: "https://www.isflive.org/s/knowledge-library",
        label: "Visit the ISF Library"
    }
]

export default () => <ModalSlot img="https://assets.swoogo.com/uploads/full/3013034-651d95c49f410.png" links={links} slots={slots} />